import { linkTemplates } from '@atlassian/mpac-utils';

import BootstrapConfig from '../../../../../../../bootstrapConfig';

export const makeLinkTemplates = () => {
  const {
    adminHubBaseUrl,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    atlassianCommunityBaseUrl,
    macBaseUrl,
    wacBaseUrl,
  } = BootstrapConfig.get();

  return linkTemplates({
    adminHubBaseUrl,
    mpacBaseUrl,
    mpacCdnBaseUrl,
    atlassianCommunityBaseUrl,
    macBaseUrl,
    wacBaseUrl,
  });
};
